import {
  GasRoutePreview,
  GasRoutesList,
  OperatingGasRoutesList,
} from '@gasbi/shared/web/Gds';
import { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

export const gdsGasRoutesRoutes: RouteObject[] = [
  {
    path: '',
    element: <GasRoutesList />,
    children: [{ path: ':gasRouteId', element: <GasRoutePreview /> }],
  },
  {
    path: Pages.OPERATING_GAS_ROUTES,
    element: <OperatingGasRoutesList />,
  },
];
